import PropTypes from "prop-types";
import { useState } from "react";
import { Dropdown } from "antd";
import CustomMoreOptions from "@/components/specific/Custom_More_Options";
import { useNavigate } from "react-router-dom";
import Delete from "@/components/common/alerts/Delete";

const RolesManagementCard = ({
  id,
  name,
  description,
  type,
  status,
  onDelete,
  onModify,
}) => {
  const navigate = useNavigate();
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);

  const handleCardClick = (e) => {
    if (e.target.closest("button")) return;
    navigate(`/dashboard/roles/${id}`);
  };

  const handleMenuClick = ({ key }) => {
    if (key === "delete") {
      setIsDeleteModalVisible(true);
    } else if (key === "modify") {
      onModify(id);
    }
  };

  const menuItems = {
    items: [
      {
        key: "modify",
        label: "Modify",
      },
      {
        key: "delete",
        label: "Delete",
      },
    ],
    onClick: handleMenuClick,
  };

  return (
    <>
      <div
        className="flex items-center w-full gap-4 p-2 bg-[var(--header-bg)] rounded-lg transition-all duration-300 cursor-pointer"
        onClick={handleCardClick}>
        <div className="flex flex-col text-left flex-1 min-w-0">
          <h3 className="text-bold font-semibold truncate">{name}</h3>
          <p className="text-small font-normal truncate">{description}</p>
        </div>

        <div className="flex flex-col min-w-0">
          <span className="text-small whitespace-nowrap font-medium">
            {type}
          </span>
          <div className="flex items-center gap-1">
            <div className="w-2 h-2 rounded-full bg-primary"></div>
            <span className="text-small-xs font-medium text-primary">
              {status}
            </span>
          </div>
        </div>

        {type !== "Default" && (
          <button
            className="p-2 hover:bg-gray-50 rounded-full flex-shrink-0 ml-auto"
            onClick={(e) => e.stopPropagation()}>
            <Dropdown menu={menuItems} trigger={["click"]}>
              <CustomMoreOptions variant="filled" orientation="vertical" />
            </Dropdown>
          </button>
        )}
      </div>

      <Delete
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onProceed={() => {
          setIsDeleteModalVisible(false);
          onDelete(id, name);
        }}
        header="Delete Role"
        paragraph={`Are you sure you want to delete "${name}"?`}
        proceedButtonText="Delete"
        cancelButtonText="Cancel"
      />
    </>
  );
};

RolesManagementCard.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.string,
  status: PropTypes.string,
  onDelete: PropTypes.func,
  onModify: PropTypes.func,
};

export default RolesManagementCard;
